module.exports = __webpack_public_path__ + "media/img/pages/profile/hslu ger 12-5488ee959e32b1c8dd90dcb73dfe917f.webp";